import { createFileRoute, redirect } from "@tanstack/react-router";

// The generator lives at /generate — redirect instead of rendering it here
// too, so there is one canonical URL and the sidebar highlight matches.
export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: () => {
    throw redirect({ to: "/generate", replace: true });
  },
});
